import React from 'react'
import {Link} from 'gatsby'
import shape1 from '../../assets/images/shape/shape1.svg'
import shape2 from '../../assets/images/shape/shape2.png'
import shape3 from '../../assets/images/shape/shape3.png'
import bannerImg from '../../assets/images/product-xgp/banner-img.png'

const PageBanner = ({pageTitle, homePageUrl, homePageText, activePageText}) => {
    return (
        <div className="productxgp-title-area">
            <div className="row container px-md-5 d-flex justify-content-start mx-auto">
                <div className="col-sm-12 col-lg-6 px-md-5 page-title-content text-lg-left align-self-center mt-md-5 mb-md-2">
                    <h1 className="mb-md-5 mb-3">{pageTitle}</h1>
                    <h3>Making cellular testing efficient</h3>
                    {/* <ul>
                        <li>
                            <Link to={homePageUrl}>
                                {homePageText}
                            </Link>
                        </li>
                        <li>{activePageText}</li>
                    </ul> */}
                </div>
                <div className="col-sm-12 col-lg-6 align-self-end d-flex justify-content-around">
                    <img src={bannerImg} alt="banner" />
                </div>
            </div>

            {/* <div className="shape-img1">
                <img src={shape1} alt="banner" />
            </div>
            <div className="shape-img2">
                <img src={shape2} alt="banner" />
            </div>
            <div className="shape-img3">
                <img src={shape3} alt="banner" />
            </div> */}
        </div>
    )
}

export default PageBanner;